/**Different error ids from Cordova Camera plugin */
export enum CameraErrorType {
    Canceled = 'user cancelled photos app',
    PermissionMissingAndroid = '20',
    PermissionMissingIos = 'has no access to camera',
    NoCamera = 'no camera available',
    NoPick = 'no image picked'
}
